export const SafeStorage = {
  set: (key, value, onError) => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      onError && onError(e)
    }
  },
  get: (key, onError) => {
    try {
      const str = localStorage.getItem(key)
      return str ? JSON.parse(str) : undefined
    } catch (e) {
      onError && onError(e)
      return undefined
    }
  },
  remove: (key, onError) => {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      onError && onError(e)
    }
  },
}



// WEBPACK FOOTER //
// ./src/common/storageUtil.js